// Used through the app to enable icon choice auto-completion
// and thus reduce typo

// PROPERTIES
// ---- System icons
export const kSystemIcons = {
    about: "history_edu",
    account: "account_circle",
    balance: "account_balance",
    assignment: "assignment",
    brain: "network_intel_node",
    bolt: "bolt",
    book: "menu_book",
    cancel: "cancel",
    check: "check",
    chevronRight: "chevron_right",
    close: 'close',
    convention: "assignment",
    dictionary: "book",
    erase: "backspace",
    error: "error",
    eye: "visibility",
    eye_off: "visibility_off",
    function: "functions",
    games: "gamepad",
    gear: "settings",
    heart: "favorite",
    help: 'help',
    key: "key",
    level: "school",
    lock: "lock",
    logout: "logout",
    menu: "menu",
    more: "more_horiz",
    play: "play_arrow",
    property: "gavel",
    psychology: "psychology",
    question: "question_mark",
    search: "search",
    smartphone: "smartphone",
    steps: "more_vert",
    support: "support",
    task: "adjust",
    timer: "timer",
    title: "title",
    theme: "bookmarks",
    trophy: "emoji_events",
    userId: "assignment_ind",
    waves: "waves",
    zoomIn: "zoom_in"
}